import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  calendarData: [],
  loading: false,
  error: null,
};

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    fetchCalendarStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCalendarSuccess(state, action) {
      state.loading = false;
      state.calendarData = action.payload;
    },
    fetchCalendarFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCalendarStart,
  fetchCalendarSuccess,
  fetchCalendarFailure,
} = calendarSlice.actions;

export default calendarSlice.reducer;